'use client';

import styles from './BannerLeft.module.css';
import { handleScroll } from '@/lib/utils/scroll';
import Link from 'next/link';
import IconReact from '@/components/ui/Icon/IconReact';

export const BannerLeft = () => {
    return (
        <div className={`${styles.left}`}>
            <div className={styles.lineTitle}>
                <span className={styles.line}></span>
                <h1 className={styles.heading}>
                   Доставляем ваши отправления <br /> быстро и надежно
                </h1>
            </div>
            <p className={styles.description}>
                Международная логистическая компания с собственной курьерской службой и сетью
                пунктов выдачи по всему миру
            </p>
            <div className={styles.buttons}>
                <button
                    className={styles.btnPrimary}
                    onClick={() => handleScroll('calculate-shipping-costs', 100)}
                >
                    <span>Рассчитать стоимость</span>
                    <IconReact name="ArrowForward" />
                </button>
                <Link href={'/points-cdek'} className={styles.btnSecondary}>
                    <IconReact name="LocationOnOutlined" />
                    <span>Найти пункт выдачи</span>
                </Link>
            </div>
            <div className={styles.features}>
                <div className={styles.feature}>
                    <div className={styles.featureIcon}>
                        <IconReact name="Star" />
                    </div>
                    <div>
                        <div className={styles.featureTitle}>Рейтинг</div>
                        <div className={styles.featureValue}>4.9 из 5</div>
                    </div>
                </div>
                <div className={styles.feature}>
                    <div className={styles.featureIcon}>
                        <IconReact name="SupportAgentRounded" />
                    </div>
                    <div>
                        <div className={styles.featureTitle}>Поддержка</div>
                        <div className={styles.featureValue}>24/7</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
